import * as React from 'react';
import { ContentContainer } from './ContentContainer';

export const SideNav: React.SFC = () => (
   <ContentContainer></ContentContainer>
);